import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceClusters from '../../space-clusters'

export const RESOURCE = {
  payload: {
    description:
      'A specific cluster of spaces that share common characteristics.',
    dimension: spaceClusters.RESOURCE.payload,
    level: 0,
    name: 'Space Cluster',
    partialId: PartialId.Standard.create('space_cluster'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
